import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import { ReactComponent as ScheduleKLogo } from '../../../../assets/icons/svg/large-icons/ic-large-form-1065.svg';
import { ReactComponent as Form1120sLogo } from '../../../../assets/icons/svg/large-icons/ic-large-form-1120s.svg';
import { ReactComponent as Form1120Logo } from '../../../../assets/icons/svg/large-icons/ic-large-form-1120.svg';
import Heading from '../../../../generic-components/Heading';
import { INTRO_DISCLAIMER_MAP, STYLES } from '../../consts';

const { INTRO } = STYLES;

export const Intro = () => {
  const navigate = useNavigate();
  const { formType } = useParams();
  const { t } = useTranslation();
  const getLogoByType = () => {
    if (formType === 'ScheduleK') {
      return <ScheduleKLogo className='mb-[12px]' />;
    }
    if (formType === 'Form1120s') {
      return <Form1120sLogo className='mb-[12px]' />;
    }
    if (formType === 'Form1120') {
      return <Form1120Logo className='mb-[12px]' />;
    }
    return '';
  };
  const handleGetStarted = () => {
    navigate(`/tax-forms/${formType}/categorize`);
  };
  return (
    <div className={INTRO.WRAPPER}>
      {getLogoByType()}
      <Heading title={t('TAX_FORM_INTRO_HEADER')} className={INTRO.HEADING} />
      <div className={INTRO.DISCLAIMER}>
        <Heading title={t('TAX_FORM_INTRO_TITLE')} className={INTRO.DISCLAIMER_HEADER} />
        <div className={INTRO.DISCLAIMER_BODY}>
          <div className={INTRO.SCROLLER}>
            <span className={INTRO.DISCLAIMER_CONTENT}>
              {t(INTRO_DISCLAIMER_MAP[formType as keyof typeof INTRO_DISCLAIMER_MAP].content)}
              <br />
              <a target='_blank' className='hover:text-action03 text-action03' href='https://www.irs.gov/' rel='noreferrer'>https://www.irs.gov/</a>
              <br />
              {t(INTRO_DISCLAIMER_MAP[formType as keyof typeof INTRO_DISCLAIMER_MAP]?.footer as any ?? '')}
            </span>
          </div>
        </div>
      </div>
      <LiliButton onClick={handleGetStarted} className={INTRO.ACTION} title={t('TAX_FORM_INTRO_CTA')} id='getStarted' />
    </div>
  );
};
